/* eslint-disable no-console */
/* eslint-disable consistent-return */
import Vue from 'vue';
import Router from 'vue-router';
import Callback from './components/Callback.vue';
import Soup from './components/Soup.vue';
import Queues from './components/Queues.vue';
import Run from './components/Run.vue';
import Spot from './components/Spot.vue';
import Form from './components/Form.vue';
import Data from './components/Data.vue';
import Restricted from './components/Restricted.vue';
import { store } from './store.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
    // {
    //   path: '/search',
    //   name: 'Search',
    //   component: Search,
    // },
    {
      path: '/queues/:id',
      name: 'Queues',
      props: true,
      component: Queues,
    },
    {
      path: '/run/:id',
      name: 'Run',
      props: true,
      component: Run,
    },
    {
      path: '/spot/:id',
      name: 'Spot',
      props: true,
      component: Spot,
    },
    {
      path: '/form/:id',
      name: 'Form',
      props: true,
      component: Form,
    },
    {
      path: '/data/:id',
      name: 'Data',
      props: true,
      component: Data,
    },
    {
      path: '/restricted',
      name: 'Restricted',
      props: true,
      component: Restricted,
    },
    {
      path: '/search',
      name: 'Search',
      component: require('./components/Search.vue').default,
    },
    {
      path: '/sets/:id',
      name: 'Sets',
      component: require('./components/Sets.vue').default,
    },
    {
      path: '/snippets/:id',
      name: 'Snippets',
      component: require('./components/Snippets.vue').default,
    },
    {
      path: '/docs/:id',
      name: 'Docs',
      component: require('./components/Docs.vue').default,
    },
    {
      path: '/tables/:id',
      name: 'Tables',
      component: require('./components/Tables.vue').default,
    },
    {
      path: '/soup',
      name: 'Soup',
      props: true,
      component: Soup,
    },
    {
      path: '/',
      name: 'Blocks',
      component: require('./components/Blocks.vue').default,
    },
    {
      path: '/feed',
      name: 'Feed',
      component: require('./components/Feed.vue').default,
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: require('./components/Integrations.vue').default,
    },
    {
      path: '/blocks',
      name: 'Blocks',
      component: require('./components/Blocks.vue').default,
    },
    {
      path: '/sources',
      name: 'Sources',
      component: require('./components/Sources.vue').default,
    },
    {
      path: '/login',
      name: 'Login',
      component: require('./components/Login.vue').default,
    },
    {
      path: '/details',
      name: 'Details',
      component: require('./components/Details.vue').default,
    },
    {
      path: '/table',
      name: 'Table',
      component: require('./components/Table.vue').default,
    },
    {
      path: '/usage',
      name: 'Usage',
      component: require('./components/Usage.vue').default,
    }
  ],
});

router.beforeEach((to, from, next) => {
  // if (to.path === from.path) return;
  store.searchIndex = 0
  if (to.path === "/" || to.path === "/callback" || localStorage.sessionId) {
    return next();
  }
  return next();

});

export default router;
